<div class="login-page">
  <app-top-nav-login [bbApp]="true"></app-top-nav-login>

  <form #logincmhaform="ngForm" class="login-page__main">
    <div class="container login-page__container">
      <div class="login-content login-page__content" role="main">
        <div class="login-form">
          <div class="login-fail" [hidden]="!errorDivVisible">
            <img src="/assets/normal_u30.svg" alt="error exclamation sign">
            <span>
              <h2>{{ errorDivHeading }}</h2>
              <p>{{ errorDivMessage }}</p>
              <div class="form-buttons">
                <button type="button" class="submit-form-button black-bg" (click)="hideErrorDiv()" aria-label="Try again">
                  {{ loginTryAgain }}
                </button>
              </div>
            </span>
          </div>

          @if (!requiresTwoFactor) {
            <h1 class="bb-login-heading login-page__heading" aria-label="Login heading">
              <strong>{{ 'loginLabel' | translate:translation }}</strong>
            </h1>

            <mat-form-field appearance="outline" floatLabel="always" aria-label="username" class="login-page__field">
              <mat-label>Email</mat-label>
              <input
                matInput
                [(ngModel)]="loginObj.username"
                class="form-control-textbox"
                name="cmhaussername"
                #username="ngModel"
                [placeholder]="'loginUsername' | translate:translation"
                required />
                @if (username.invalid && username.touched) {
                  <mat-error>
                    {{ 'globalFieldRequired' | translate:translation }}
                  </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always" aria-label="password" class="login-page__field login-page__field--password">
                <mat-label>Password</mat-label>
                <span matPrefix class="login-page__field-prefix" aria-hidden="true">
                  <fa-icon [icon]="faLock"></fa-icon>
                </span>
                <input
                  matInput
                  type="{{ revealPassword ? 'text' : 'password' }}"
                  [(ngModel)]="loginObj.password"
                  class="form-control-textbox"
                  #password="ngModel"
                  [placeholder]="'loginPassword' | translate:translation"
                  required
                  name="cmhapassword" />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    class="login-page__password-toggle"
                    (click)="revealPassword = !revealPassword"
                    [attr.aria-label]="revealPassword ? 'Hide password' : 'Show password'"
                    [attr.aria-pressed]="revealPassword">
                    <fa-icon [icon]="revealPassword ? faEyeSlash : faEye"></fa-icon>
                  </button>
                  @if (password.invalid && password.touched) {
                    <mat-error>
                      {{ 'globalFieldRequired' | translate:translation }}
                    </mat-error>
                  }
                </mat-form-field>

                <div class="rememberme login-page__remember">
                  <span>
                    <input type="checkbox" id="rememberme" name="rememberMe" [(ngModel)]="loginObj.rememberMe">
                    <label for="rememberme">Remember Me</label>
                  </span>
                  <span>
                    <a href="/forgot-password/bbapp" class="forgot-password" aria-label="Forgot password link">
                      {{ 'loginForgotPassword' | translate:translation }}
                    </a>
                  </span>
                </div>

                <div class="form-buttons login-page__submit">
                  <button
                    type="submit"
                    (click)="loginCMHA(logincmhaform)"
                    class="bb-login-button"
                    aria-label="login button"
                    [disabled]="isLoading"
                    #submitButton>
                    @if (!isLoading) {
                      {{ 'loginLabel' | translate:translation }}
                    } @else {
                      <div class="loader"><img src="/assets/loader.gif" class="login-loader" alt="Loading"></div>
                    }
                  </button>
                </div>

                <div class="noaccount login-page__noaccount">
                  <p>Don't have an account? <a routerLink="/aboutus" class="forgot-password">Learn More</a></p>
                </div>
          } @else {
            <div class="login-otp">
              <h1 class="bb-login-heading login-page__heading login-otp__heading" aria-label="OTP heading">
                <strong>{{ 'loginOtpHeading' | translate:translation }}</strong>
              </h1>

              <div class="login-otp__card" role="status">
                <div class="login-otp__icon" aria-hidden="true">
                  <fa-icon [icon]="faEnvelope"></fa-icon>
                </div>
                <p class="login-otp__prompt">
                  {{ 'loginOtpPrompt' | translate:translation }}
                  <span class="login-otp__email">{{ loginObj.username }}</span>
                </p>
                <p class="login-otp__expiry">{{ 'loginOtpExpiry' | translate:translation }}</p>
              </div>

              <mat-form-field appearance="outline" floatLabel="always" aria-label="otp code" class="login-page__field login-otp__field">
                <mat-label>{{ 'loginOtpCode' | translate:translation }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="otpCode"
                  class="form-control-textbox login-otp__input"
                  name="otpCode"
                  #otpCodeInput="ngModel"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  maxlength="6"
                  pattern="[0-9]{6}"
                  [placeholder]="'loginOtpPlaceholder' | translate:translation"
                  (input)="otpCode = otpCode.replace(/\D/g, '').slice(0, 6)"
                  required />
                @if (otpCodeInput.invalid && otpCodeInput.touched) {
                  <mat-error>
                    {{ 'globalFieldRequired' | translate:translation }}
                  </mat-error>
                }
              </mat-form-field>

              <div class="form-buttons login-page__submit">
                <button
                  type="button"
                  (click)="verifyOtp(logincmhaform)"
                  class="bb-login-button login-otp__verify"
                  aria-label="verify otp button"
                  [disabled]="isLoading"
                  #submitButton>
                  @if (!isLoading) {
                    {{ 'loginOtpVerify' | translate:translation }}
                  } @else {
                    <div class="loader"><img src="/assets/loader.gif" class="login-loader" alt="Loading"></div>
                  }
                </button>
              </div>

              <div class="login-otp__actions">
                <button
                  type="button"
                  class="login-otp__back"
                  (click)="backToPasswordStep()"
                  [disabled]="isLoading"
                  aria-label="back to login">
                  {{ 'loginOtpBack' | translate:translation }}
                </button>
                <button
                  type="button"
                  class="login-otp__resend"
                  (click)="resendOtp()"
                  [disabled]="isResendingOtp || isLoading"
                  aria-label="resend otp">
                  {{ 'loginOtpResend' | translate:translation }}
                </button>
              </div>
            </div>
          }
            </div>
          </div>
        </div>
      </form>

      <app-footer [bbapp]="true" [showLogos]="true" [showBrandImage]="false"></app-footer>
    </div>
